export interface ReadOnlyStore<T> {
  get(): T;
  subscribe(cb: (value: T) => void): () => void;
}

export interface MutableStoreHandle<T> {
  store: ReadOnlyStore<T>;
  set(next: T): void;
}

export function createStore<T>(initial: T): MutableStoreHandle<T> {
  let value: T = initial;
  const subs = new Set<(v: T) => void>();
  return {
    store: {
      get: () => value,
      subscribe: (cb) => {
        subs.add(cb);
        return () => {
          subs.delete(cb);
        };
      },
    },
    set: (next: T) => {
      if (Object.is(next, value)) return;
      value = next;
      for (const cb of subs) cb(value);
    },
  };
}
